import { Link } from "@mui/material";
import clsx from "clsx";
import {
  ButtonHTMLAttributes,
  MouseEvent,
  PropsWithChildren,
  ReactNode,
  RefObject,
  type JSX,
} from "react";
import "./styles.scss";

export interface IActionLinkProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "content"> {
  content: ReactNode;
  label?: string;
  linkRef?: RefObject<HTMLButtonElement | null>;
  onClick?: (ev: MouseEvent) => void;
  showTappableArea?: boolean;
  useStopPropagation?: boolean;
  ariaProps?: { [key: string]: unknown };
  style?: React.CSSProperties;
}

const ActionLink = ({
  className,
  content,
  disabled,
  label,
  linkRef,
  onClick,
  showTappableArea,
  useStopPropagation,
  ariaProps,
  id,
  style,
}: PropsWithChildren<IActionLinkProps>): JSX.Element => {
  return (
    <Link
      component="button"
      className={clsx(
        "action-link",
        { "show-tap-area": showTappableArea },
        className
      )}
      aria-label={label}
      disabled={disabled}
      onClick={(e: MouseEvent) => {
        if (useStopPropagation && e.stopPropagation) {
          e.stopPropagation();
        }
        if (onClick) {
          onClick(e);
        }
      }}
      ref={linkRef}
      tabIndex={0}
      id={id}
      {...ariaProps}
      underline="hover"
      style={style}
    >
      <div className="content-container">{content}</div>
    </Link>
  );
};

export default ActionLink;
